import { render, staticRenderFns } from "./BubbleSettings.vue?vue&type=template&id=2d25c4f1&scoped=true"
import script from "./BubbleSettings.vue?vue&type=script&lang=js"
export * from "./BubbleSettings.vue?vue&type=script&lang=js"
import style0 from "./BubbleSettings.vue?vue&type=style&index=0&id=2d25c4f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25c4f1",
  null
  
)

export default component.exports